export default __webpack_public_path__ + "static/media/content_writing.bc12b1a0.gif";